import { QueryClient } from '@tanstack/react-query';

/**
 * 4xx responses from PostgREST (401 missing JWT, 403 RLS-blocked, 404
 * not-found, 406 single-row not-found) are not transient — retrying them
 * just doubles the failed-request count and delays the error banner the
 * route renders via <ErrorState>. Only retry on 5xx and network-level
 * failures.
 */
function shouldRetryQuery(failureCount: number, err: unknown): boolean {
  if (failureCount >= 1) return false;
  // Supabase / PostgREST errors don't have a standard shape; sniff the
  // status off the closest field that carries it.
  const e = err as { status?: unknown; statusCode?: unknown; code?: unknown };
  const status =
    typeof e?.status === 'number'
      ? e.status
      : typeof e?.statusCode === 'number'
        ? e.statusCode
        : undefined;
  if (typeof status === 'number' && status >= 400 && status < 500) return false;
  return true;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: shouldRetryQuery,
    },
    mutations: {
      retry: 0,
    },
  },
});
